export default __webpack_public_path__ + "static/media/Roboto.03523cf5.ttf";